// extracted by css-extract-rspack-plugin
export default {"cls1":"ScrollableTabNav-wjs-cls1_7IP","cls2":"ScrollableTabNav-wjs-cls2_Lpn ScrollableTabNav-wjs-cls1_7IP","u-floatLeft":"ScrollableTabNav-wjs-u-floatLeft_9qU"};